const boxStyle = {
    root: {
        backgroundColor: 'white', 
        borderRadius: '5px',
        padding: 1
      },
  };
  
  export default boxStyle;